import { render, staticRenderFns } from "./FingerprintChange.vue?vue&type=template&id=54b0c0e9"
import script from "./FingerprintChange.vue?vue&type=script&lang=js"
export * from "./FingerprintChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports